import { ref } from 'vue'

const toasts = ref([])
let toastId = 0

export const useToast = () => {
  const showToast = (messageOrOptions, type = 'info', duration = 5000) => {
    let finalMessage = ''
    let finalType = type
    
    if (typeof messageOrOptions === 'object') {
      const options = messageOrOptions
      finalMessage = options.description || options.title || options.message || ''
      finalType = options.variant === 'destructive' ? 'error' : (options.variant || options.type || type)
      duration = options.duration !== undefined ? options.duration : duration
    } else {
      finalMessage = messageOrOptions
    }

    const id = toastId++
    const toastItem = {
      id,
      message: finalMessage,
      type: finalType,
      duration
    }
    
    toasts.value.push(toastItem)
    
    if (duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, duration)
    }
    
    return id
  }
  
  const removeToast = (id) => {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }
  
  const clearAll = () => {
    toasts.value.length = 0
  }
  
  const toast = showToast

  return {
    toasts,
    showToast,
    toast,
    removeToast,
    clearAll
  }
}